module.exports = __webpack_public_path__ + "static/media/close-theme.77d2176b.svg";